import React from 'react'
import {connect} from "react-redux";
import Booster from "./booster";
import Dccgen from "./dccgen";
import {hasDccgen, hasBooster} from "../bidib/bidib_commons";

const Dcc = ({boosters, dccgens}) => {
    return (
        <>
            {dccgens.map(dccgen => (
                <Dccgen key={dccgen.uid} dccgen={dccgen} boosters={boosters}/>
            ))}
            {boosters.map(booster => (
                <Booster key={booster.uid} booster={booster}/>
            ))}
        </>
    );
}

function mapStateToProps(state, other) {

    const dcc = state.bidib.data.node.filter(it =>
        it.type === "node" && hasDccgen(it.classid)
    )

    const bst = state.bidib.data.node.filter(it =>
        it.type === "node" && hasBooster(it.classid)
    )

    return {dccgens: dcc, boosters: bst}
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Dcc)
